import { RouteFallback } from '@web/router/fallback'
import { type ReactNode, useEffect, useState } from 'react'

type ServiceWebBootProps = {
  init: () => void | Promise<void>
  children: ReactNode
}

export function ServiceWebBoot({ init, children }: ServiceWebBootProps) {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    let cancelled = false

    void Promise.resolve(init()).finally(() => {
      if (!cancelled) {
        setIsReady(true)
      }
    })

    return () => {
      cancelled = true
    }
  }, [init])

  if (!isReady) {
    return <RouteFallback />
  }

  return children
}
